import React from 'react';
import type IssueTypesDirectory from '@atlassian/jira-spa-apps-admin-pages-issue-types-directory/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyIssueTypesDirectory = lazyForPaint<typeof IssueTypesDirectory>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-admin-pages-issue-types-directory", jiraSpaEntry: "async-admin-pages-issue-types-directory" */ '@atlassian/jira-spa-apps-admin-pages-issue-types-directory'
		),
	),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyIssueTypesDirectory}
		pageId="jira-admin-pages-issue-types-directory"
		shouldShowSpinner
	/>
);
